import { getGlobalCssUrl } from '../Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createControlInfoTemplate() {
    const t = document.createElement('template')
    t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<style>
</style>
`
    return t;
}

const getTemplateControlInfoStyles = () => createControlInfoTemplate();
export { getTemplateControlInfoStyles };
